(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tumbler-design-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('kkb-tumbler-filter')) return;

  const normalize = value =>
    String(value || '').trim().normalize('NFC').toLocaleLowerCase();

  class KkbTumblerFilter extends HTMLElement {
    connectedCallback() {
      this.start = () => this.initialize();

      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          this.start,
          { once: true }
        );
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;

      this.root = this.closest('product-info');
      this.category = this.querySelector('[data-kkb-category]');
      this.status = this.querySelector('[data-kkb-status]');

      if (!this.root || !this.category) return;

      this.initialized = true;
      this.cache = new WeakMap();
      this.names = new Map();

      (this.dataset.categories || '').split(/\r?\n/).forEach(name => {
        name = name.trim();
        const key = normalize(name);

        if (key && !this.names.has(key)) {
          this.names.set(key, name);
        }
      });

      this.other = normalize(this.dataset.other || 'Other');

      if (!this.names.has(this.other)) {
        this.names.set(this.other, this.dataset.other || 'Other');
      }

      this.assignments = new Map();

      (this.dataset.assignments || '').split(/\r?\n/).forEach(line => {
        const separator = line.indexOf('|');
        if (separator < 1) return;

        const design = normalize(line.slice(0, separator));

        const categories = line
          .slice(separator + 1)
          .split(';')
          .map(normalize)
          .filter(key => this.names.has(key));

        const previous = this.assignments.get(design) || new Set();

        categories.forEach(key => previous.add(key));
        this.assignments.set(design, previous);
      });

      this.names.forEach((name, key) => {
        const option = document.createElement('option');
        option.value = key;
        option.textContent = name;
        this.category.append(option);
      });

      this.onCategory = () => this.apply(true);
      this.category.addEventListener('change', this.onCategory);

      this.schedule = () => {
        if (this.pending) return;

        this.pending = true;

        queueMicrotask(() => {
          this.pending = false;
          if (this.isConnected) this.apply(false);
        });
      };

      this.observer = new MutationObserver(this.schedule);
      this.root.addEventListener('variant-selects:loaded', this.schedule);

      this.observe();
      this.apply(false);
    }

    observe() {
      this.observer.observe(this.root, {
        childList: true,
        subtree: true
      });
    }

    matches(option, category) {
      if (!category) return true;

      const assigned = this.assignments.get(normalize(option.value));

      return assigned && assigned.size
        ? assigned.has(category)
        : category === this.other;
    }

    apply(userChanged) {
      const picker = Array.from(
        this.root.querySelectorAll('variant-selects')
      ).find(node => node.style.display !== 'none');

      const select = picker?.querySelector(
        'select[name="options[Choose Your Design]"]'
      );

      if (!select) {
        this.hidden = true;
        return;
      }

      this.observer.disconnect();

      try {
        let originals = this.cache.get(select);

        if (!originals) {
          originals = Array.from(select.options);
          this.cache.set(select, originals);
        }

        if (!originals.length) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const previousValue = select.value;

        Array.from(this.category.options).forEach(option => {
          option.disabled = !!option.value &&
            !originals.some(design =>
              this.matches(design, option.value)
            );
        });

        let category = this.category.value;

        let matches = originals.filter(option =>
          this.matches(option, category)
        );

        let resetMessage = '';

        if (!matches.length) {
          this.category.value = '';
          category = '';
          matches = originals;
          resetMessage =
            'No matching choices for this selection. Showing all designs. ';
        }

        let nextValue = previousValue;

        if (!matches.some(option => option.value === nextValue)) {
          if (!userChanged) {
            this.category.value = '';
            category = '';
            matches = originals;
            resetMessage =
              'Showing all designs for the current selection. ';
          } else {
            nextValue = matches[0].value;
          }
        }

        // Preserve Debutify's normal variant change handling.
        select.replaceChildren(...originals);
        select.value = nextValue;

        if (nextValue !== previousValue) {
          select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }

        select.replaceChildren(...matches);
        select.value = nextValue;

        const selected = matches.find(
          option => option.value === nextValue
        );

        if (selected) {
          originals.forEach(option => {
            if (option === selected) {
              option.setAttribute('selected', 'selected');
            } else {
              option.removeAttribute('selected');
            }
          });

          const label = select
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value]');

          if (label && label.textContent !== selected.value) {
            label.textContent = selected.value;
          }
        }

        const count = matches.length;

        this.status.textContent =
          resetMessage +
          count +
          (count === 1 ? ' design' : ' designs') +
          (category
            ? ' in ' + this.names.get(category)
            : ' available');
      } finally {
        this.observe();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);

      this.observer?.disconnect();

      this.root?.removeEventListener(
        'variant-selects:loaded',
        this.schedule
      );

      this.category?.removeEventListener('change', this.onCategory);

      const select = Array.from(
        this.root?.querySelectorAll('variant-selects') || []
      )
        .find(node => node.style.display !== 'none')
        ?.querySelector('select[name="options[Choose Your Design]"]');

      const originals = select && this.cache?.get(select);

      if (originals) {
        const value = select.value;
        select.replaceChildren(...originals);
        select.value = value;
      }

      this.initialized = false;
    }
  }

  customElements.define('kkb-tumbler-filter', KkbTumblerFilter);
})();
  } catch(e) { console.error(e); }
})();

})();
